import { Api } from "telegram";
import { apiLogout, removeChannels } from "../../store/reducers/root";

export default async function logOut(client, dispatch, setLoading) {
  setLoading(true);
  const isLoggedIn = await client.isUserAuthorized();
  if (isLoggedIn) {
    await client.invoke(new Api.auth.LogOut({}));
  }
  dispatch(apiLogout());
  dispatch(removeChannels());
  setLoading(false);
}
